// Device Fingerprinting Utility
// Generates a unique device ID based on browser characteristics

const generateDeviceFingerprint = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('Device fingerprint', 2, 2);
  
  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency,
    navigator.deviceMemory,
    navigator.platform,
    canvas.toDataURL(),
    navigator.cookieEnabled,
    navigator.doNotTrack,
    navigator.maxTouchPoints,
    'ontouchstart' in window,
    'ondeviceorientation' in window,
    'ondevicemotion' in window
  ].join('|');
  
  // Create a hash of the fingerprint
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs(hash).toString(36);
};

// Get or create device ID
export const getDeviceId = () => {
  let deviceId = localStorage.getItem('wow_pizza_device_id');
  
  if (!deviceId) {
    deviceId = generateDeviceFingerprint();
    localStorage.setItem('wow_pizza_device_id', deviceId);
  }
  
  return deviceId;
};

// Get device info for API calls
export const getDeviceInfo = () => {
  return {
    deviceId: getDeviceId(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenResolution: `${screen.width}x${screen.height}`,
    timestamp: new Date().toISOString()
  };
}; 